import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'index',
            component: () =>
                import ('@/pages/index')
        },
        {
            path: '/case',
            name: 'case',
            component: () =>
                import ('@/pages/case')
        },
        {
            path: '/intro',
            name: 'intro',
            component: () =>
                import ('@/pages/intro')
        },
        {
            path: '/product',
            name: 'product',
            component: () =>
                import ('@/pages/product')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () =>
                import ('@/pages/contact')
        },
    ],
})


// WEBPACK FOOTER //
// ./src/router/index.js